/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function getLocation(params) {
    // https://yuque.antfin.com/docs/share/9f7861ac-8c8d-4226-9d46-794b951af427?# 《小二App API接口列表文档》
    WVCall('SensorModule.getLocation', params);
}

export { getLocation as default };
